import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import SummaryHeader from './SummaryHeader';

interface Props {
	className?: string;
	price?: React.ReactNode;
	header?: string;
}

const SummaryItem: React.FC<Props> = ({ className, price, header, children }) => {
	const theme = useTheme('PaymentForm').Summary;

	return (
		<div className={theme.item}>
			{header && <SummaryHeader>{header}</SummaryHeader>}

			<div className={cn(theme.item__content, className)}>
				<div>{children}</div>

				{price}
			</div>
		</div>
	);
};

export default SummaryItem;
